/**
 * AdminOrcaContainerRpcClient - AtomRpc integration for admin orca container endpoints
 *
 * Requires admin authentication via Clerk session token.
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { AdminOrcaContainerRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { makeRpcClientLayer, makeTokenGetterLayer } from "./shared.ts";

export class AdminOrcaContainerRpcClient extends AtomRpc.Tag<AdminOrcaContainerRpcClient>()(
  "AdminOrcaContainerRpcClient",
  {
    group: AdminOrcaContainerRpcs,
    protocol: makeRpcClientLayer(AdminOrcaContainerRpcs).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
